import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { LookupTipoLayoutDanfeResponse } from '../../responses/report/lookup-tipo-layout-danfe.response';
import { LookupTipoSeparadorImpressaoTermicaResponse } from '../../responses/report/lookup-tipo-separador-impressao-termica.response';
import { LookupTipoFonteDanfeResponse } from '../../responses/report/lookup-tipo-fonte-danfe.response';

/** Catálogos de impressão do db_report, lidos pela API Report. */
@Injectable({
  providedIn: 'root',
})
export class ReportLookupService extends CommonService {
  private readonly apiUrl = `${environment.urlApiReport}Lookup`;

  constructor(private httpClient: HttpClient) {
    super();
  }

  /** Corresponde a: [HttpGet] /Lookup/tipo-layout-danfe */
  public getTiposLayoutDanfe(): Observable<LookupTipoLayoutDanfeResponse> {
    return this.httpClient
      .get<LookupTipoLayoutDanfeResponse>(`${this.apiUrl}/tipo-layout-danfe`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /** Corresponde a: [HttpGet] /Lookup/tipo-separador-impressao-termica */
  public getTiposSeparadorImpressaoTermica(): Observable<LookupTipoSeparadorImpressaoTermicaResponse> {
    return this.httpClient
      .get<LookupTipoSeparadorImpressaoTermicaResponse>(`${this.apiUrl}/tipo-separador-impressao-termica`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /** Corresponde a: [HttpGet] /Lookup/tipo-fonte-danfe */
  public getTiposFonteDanfe(): Observable<LookupTipoFonteDanfeResponse> {
    return this.httpClient
      .get<LookupTipoFonteDanfeResponse>(`${this.apiUrl}/tipo-fonte-danfe`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
